import { getRequiredBranchHeaders } from './branchStorage';

/**
 * ทุกหน้าในแอดมิน (ยกเว้นหน้ารายงานที่เรียก getReportBranchHeaders() เองอยู่แล้ว
 * เช่น Dashboard.jsx, Transactions.jsx, TransactionHistory.jsx) ยิง fetch() ตรง ๆ
 * ไปที่ apiUrl/printerUrl โดยไม่ผ่าน helper กลางไหนเลย — แก้ทีละจุดกว่า 70 จุดใน
 * ~19 ไฟล์เสี่ยงตกหล่นและ diff ใหญ่เกินจำเป็น จึง patch window.fetch ครั้งเดียว
 * ให้แนบ X-Branch-Id อัตโนมัติเฉพาะ request ที่ไปที่ backend เหล่านี้ และเฉพาะตอนที่
 * ผู้เรียกยังไม่ได้ใส่ header สาขามาเอง (เคารพ Dashboard.jsx ที่ตั้งค่าเองไว้ก่อนแล้ว)
 */
export function installBranchFetch(apiBases) {
  if (window.__branchFetchInstalled) return;
  window.__branchFetchInstalled = true;

  const bases = apiBases.filter(Boolean);
  const originalFetch = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url ?? '';
    const isBackendCall = bases.some((base) => url.startsWith(base));
    if (!isBackendCall) return originalFetch(input, init);

    const headers = new Headers(init.headers ?? (typeof input === 'string' ? undefined : input.headers));

    // requireBranchContext (backend) เชื่อ X-Branch-Id ก็ต่อเมื่อรู้ว่าผู้เรียกเป็นเจ้าของร้าน
    // (req.admin?.isOwner) ซึ่งต้องมี Authorization ก่อนถึงจะเซ็ตได้ — หน้าไหนลืมแนบ token เอง
    // (เช่น เรียก endpoint ที่ตั้งใจให้ public ด้วย อย่าง /api/settings/pricing,
    // /api/categories) header สาขาที่แนบไปด้านล่างนี้จะถูกเมินเงียบ ๆ แล้วตกไปใช้ fallback
    // "สาขาเดียวที่ active" ซึ่งพังทันทีที่มีมากกว่า 1 สาขา — แนบให้เองที่นี่เผื่อไว้เลย
    let hasAuth = headers.has('Authorization');
    if (!hasAuth) {
      const token = localStorage.getItem('adminToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
        hasAuth = true;
      }
    }

    if (!headers.has('X-Branch-Id') && !headers.has('X-Branch-Scope')) {
      const branchHeaders = getRequiredBranchHeaders();
      Object.entries(branchHeaders).forEach(([key, value]) => headers.set(key, value));
    }

    return originalFetch(input, { ...init, headers }).then((response) => {
      // 401 ตอนที่เราแนบ token ไปด้วยแล้ว = token หมดอายุ/ใช้ไม่ได้แล้ว (401 สงวนไว้สำหรับ
      // ปัญหา token เท่านั้น ปัญหาสิทธิ์ใช้ 403 — ดู middleware/auth.js) ไม่ใช่ 401 จาก
      // การเรียก login เองตอนยังไม่มี token เลย ล้าง token แล้วรีโหลดให้ App.jsx เช็คใหม่
      // แล้วตกไปที่หน้า Login (ไม่มี route /login แยก — App.jsx render จาก state ตรง ๆ)
      if (response.status === 401 && hasAuth && !window.__branchFetchExpiring) {
        window.__branchFetchExpiring = true;
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminRole');
        localStorage.removeItem('adminManagerBranchId');
        window.location.reload();
      }
      return response;
    });
  };
}
